import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { FC } from 'react';
import MiViewScreenCepActivities from '../Screens/MiViewScreenCepActivities/MiViewScreenCepActivities';
import useMiViewScreenLayout from './MiViewScreenLayout.hook';
import { boxStyle, gridContainerStyle, gridStyle, paperStyle, screenStyle } from './MiViewScreenLayout.style';
import { MiViewScreen } from 'basics/enums/miview.enums';
import MiViewScreenCepTargets from 'components/MiViewPreview/Screens/MiViewScreenCepTargets/MiViewScreenCepTargets';

const MiViewScreenLayout: FC = () => {
  const {
    firstScreen,
    setFirstScreen,
    secondScreen,
    setSecondScreen,
    fullScreenFirstScreen,
    setFullScreenFirstScreen,
    fullScreenSecondScreen,
    setFullScreenSecondScreen,
    IVADocuments,
    AEDocuments,
    loading,
  } = useMiViewScreenLayout();

  const ScreenStyled = styled(Paper)(() => ({ ...paperStyle }));

  return (
    <Box display="flex" flexDirection="column" height="100%" sx={ boxStyle }>
      <Grid container sx={ gridContainerStyle }>
        <Grid item={ true } md={ 12 } lg={ fullScreenFirstScreen ? 12 : 6 } height={ '50%' }
          sx={ { ...gridStyle, display: `${fullScreenSecondScreen ? 'none' : 'block'}` } }
        >
          <ScreenStyled style={ screenStyle }>
            {
              firstScreen === MiViewScreen.cepTargets ? (
                <MiViewScreenCepTargets
                  defaultScreen={ firstScreen }
                  setNewScreen={ setFirstScreen }
                  fullScreen={ fullScreenFirstScreen }
                  setFullScreen={ setFullScreenFirstScreen }
                  IVADocuments={ IVADocuments }
                  AEDocuments={ AEDocuments }
                  generalLoading={ loading }
                >
                </MiViewScreenCepTargets>
              ) : (
                <MiViewScreenCepActivities
                  defaultScreen={ firstScreen }
                  setNewScreen={ setFirstScreen }
                  fullScreen={ fullScreenFirstScreen }
                  setFullScreen={ setFullScreenFirstScreen }
                  IVADocuments={ IVADocuments }
                  AEDocuments={ AEDocuments }
                  generalLoading={ loading }
                ></MiViewScreenCepActivities>
              )
            }
          </ScreenStyled>
        </Grid>

        <Grid item={ true } md={ 12 } lg={ fullScreenSecondScreen ? 12 : 6 } height={ '50%' }
          sx={ { ...gridStyle, display: `${fullScreenFirstScreen ? 'none' : 'block'}` } }
        >
          <ScreenStyled style={ screenStyle }>
            {
              secondScreen === MiViewScreen.cepActivities ? (
                <MiViewScreenCepActivities
                  defaultScreen={ secondScreen }
                  setNewScreen={ setSecondScreen }
                  fullScreen={ fullScreenSecondScreen }
                  setFullScreen={ setFullScreenSecondScreen }
                  IVADocuments={ IVADocuments }
                  AEDocuments={ AEDocuments }
                  generalLoading={ loading }
                ></MiViewScreenCepActivities>
              ) : (
                <MiViewScreenCepTargets
                  defaultScreen={ secondScreen }
                  setNewScreen={ setSecondScreen }
                  fullScreen={ fullScreenSecondScreen }
                  setFullScreen={ setFullScreenSecondScreen }
                  IVADocuments={ IVADocuments }
                  AEDocuments={ AEDocuments }
                  generalLoading={ loading }
                ></MiViewScreenCepTargets>
              )
            }
          </ScreenStyled>
        </Grid>
      </Grid>
    </Box>
  );
};

export default MiViewScreenLayout;
